import * as types from 'store/actions/types';
import services from 'services/services';

// Import helpers
import { getErrorCodeResults } from 'helpers/error_code_api';
import { sendGTMEvent } from 'helpers/tracking';

// Import Variables
import { TRANSACTION_TYPES } from 'helpers/prices';
import {
	GTM_TRACKING_EVENTS,
	ALLOWED_GTM_PAYMENT_STATUSES
} from 'helpers/tracking';

const { PURCHASE, SUBSCRIPTION } = TRANSACTION_TYPES;
const { PURCHASE: GTM_PURCHASE } = GTM_TRACKING_EVENTS;

// ******************** SUBMIT PRODUCT PURCHASE ********************
export const checkTransactionStatus = (orderId) => async (dispatch) => {
	try {
		// Dispatch an loading action
		dispatch({
			type: types.TRANSACTION_FINALIZATION_LOADING
		});

		let url = `/payments/payment/${orderId}`;

		const { data } = await services.get(url);

		// Dispatch an action
		dispatch({
			type: types.TRANSACTION_FINALIZATION_SUCCESS,
			// FIX NAMING WHEN API READY
			payload: data
		});

		const {
			final_price,
			payment_method,
			product_title,
			status,
			gateway_type,
			confirmation_status
		} = data;

		const type =
			payment_method === 'packets_subscription' ? SUBSCRIPTION : PURCHASE;

		const isGTMEventValid = ALLOWED_GTM_PAYMENT_STATUSES.includes(
			confirmation_status
		);

		isGTMEventValid &&
			sendGTMEvent({
				event: GTM_PURCHASE,
				customEventData: {
					type,
					status,
					payment_method,
					price: final_price,
					product: product_title,
					order_id: orderId,
					gateway_type,
					confirmation_status
				}
			});
	} catch (error) {
		if (error.response) {
			const { codeErrorMessage } = getErrorCodeResults(error);

			// Dispatch an error action
			error.response.data.message = codeErrorMessage;
		}

		// Dispatch an error action
		dispatch({
			type: types.TRANSACTION_FINALIZATION_ERROR,
			payload: error
		});
	}
};

export const clearTransaction = (dispatch) => {
	dispatch({
		type: types.TRANSACTION_FINALIZATION_CLEAR
	});
};

export const clearTransactionStatus = () => (dispatch) => {
	dispatch({
		type: types.TRANSACTION_FINALIZATION_LOADING
	});
};
